<template>
  <span v-if="disabled && printMode" class="showText">{{userName}}</span>
  <el-input
    v-else
    :size="size"
    :value="userName"
    readonly="readonly"
    suffix-icon="el-icon-user"
  ></el-input>
</template>
<script>
export default {
  name: "l-createuser",
  props: {
    value: String,
    disabled:Boolean,
    size: {
      type: String,
      default: "mini",
    },
    printMode: {
      default: false
    },
    showWokerNumber: {
      default: false
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (!this.$validatenull(newVal)) {
          this.lr_loadUsers && this.lr_loadUsers(newVal);
        }
        if (this.$validatenull(newVal) && this.loginInfo) {
          this.lr_loadUsers && this.lr_loadUsers(this.loginInfo.f_UserId);
          this.$emit("input", this.loginInfo.f_UserId);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    userName() {
      if (this.lr_users) {
        let str = (this.lr_users[this.value] || {}).f_RealName || ""
        if (this.showWokerNumber) str += `[${(this.lr_users[this.value] || {}).f_Account}]`
        return str;
      } else {
        return "";
      }
    },
  },
};
</script>